// removed by extract-text-webpack-plugin
module.exports = {"RoleCreate":"RoleCreate--8K_7s","Name":"Name--2rMN2","Base":"Base--2TUVt","Expiry":"Expiry--1Wzs-"};